import ms from './ms';

const id = {
  ...ms,
  login: {
    ...ms.login,
    subtitle: 'Masuk untuk melanjutkan',
    loginName: 'Nama Login',
    submit: 'Masuk',
    submitting: 'Sedang masuk…',
    failed: 'Gagal masuk',
    heroTitle: 'Sistem Operasi Perusahaan Cerdas',
    heroDesc: 'Otomatiskan operasi, lacak pemesanan, dan kelola seluruh alur kerja operasional Anda di satu tempat.',
    forgotPassword: 'Lupa kata sandi?',
    securityNote: 'Koneksi Anda terenkripsi dan aman.',
    selectTenant: 'Pilih workspace',
    tenantWorkspace: 'Workspace Tenant',
  },
  dashboard: {
    ...ms.dashboard,
    title: 'Dasbor',
    welcome: 'Selamat datang kembali, {{name}}',
  },
  category: {
    ...ms.category,
    home: 'Beranda',
    builder: 'Business Builder',
    inbox: 'Kotak Masuk',
    business: 'Bisnis',
    transport: 'Transportasi Klasik',
    freight: 'Pilot Freight',
    warehouse: 'Alur Gudang',
    haulage: 'Komando Haulage',
    'supply-chain': 'Navigator Rantai Pasok',
    depot: 'Kontrol Depot',
    finance: 'Keuangan',
    workforce: 'Tenaga Kerja',
    settings: 'Pengaturan',
    platform: 'Platform',
  },
  module: {
    ...ms.module,
    hms: 'Komando Haulage',
    tms: 'Transportasi Klasik',
    wms: 'Alur Gudang',
    fms: 'Pilot Freight',
    scm: 'Navigator Rantai Pasok',
  },
  group: {
    ...ms.group,
    Messages: 'Pesan',
    Tasks: 'Tugas',
    Purchase: 'Pembelian',
    People: 'Orang',
    Branches: 'Cabang',
    Access: 'Akses',
    Setup: 'Pengaturan',
    Reports: 'Laporan',
    Monitor: 'Monitor',
    tax: 'Pajak',
    email: 'Email',
    dashboard: 'Dasbor',
    orders: 'Pesanan',
    operations: 'Operasional',
    import: 'Impor',
    export: 'Ekspor',
    master: 'Master Data',
    Import: 'Impor',
    Export: 'Ekspor',
    Master: 'Master Data',
    overview: 'Ringkasan',
    planning: 'Perencanaan',
    tools: 'Alat',
    banking: 'Perbankan',
    AR: 'Piutang Usaha',
    AP: 'Utang Usaha',
    GL: 'Buku Besar',
    einvoicing: 'E-Faktur',
    admin: 'Admin',
    'self-service': 'Layanan Mandiri',
    Driver: 'Pengemudi',
  },
  nav: {
    ...ms.nav,
    chat: 'AI Chat',
    home: 'Beranda',
    Dashboard: 'Dasbor',
    Shipments: 'Pengiriman',
    Shipment: 'Pengiriman',
    Containers: 'Kontainer',
    Container: 'Kontainer',
    Cargo: 'Kargo',
    Costing: 'Costing',
    Billing: 'Billing',
    Rates: 'Tarif',
    Documents: 'Dokumen',
    Import: 'Impor',
    Export: 'Ekspor',
    Transhipment: 'Transshipment',
    'Cross Trade': 'Cross Trade',
    Local: 'Lokal',
    Consol: 'Konsolidasi',
    Air: 'Udara',
    'Shipment Report': 'Laporan Pengiriman',
    'Billing Report': 'Laporan Billing',
    'Imp Shipment': 'Pengiriman Impor',
    'Imp Container': 'Kontainer Impor',
    'Imp Cargo': 'Kargo Impor',
    'Exp Shipment': 'Pengiriman Ekspor',
    'Exp Booking': 'Booking Ekspor',
    'Exp Container': 'Kontainer Ekspor',
    'Exp Cargo': 'Kargo Ekspor',
    'Inv / Cost Note': 'Invoice / Cost Note',
    'Charge Lines': 'Baris Biaya',
    Invoices: 'Faktur',
    Receipts: 'Kuitansi',
    'AR Aging': 'Umur Piutang',
    'Vendor Bills': 'Tagihan Pemasok',
    Payments: 'Pembayaran',
    'Journal Entries': 'Jurnal Umum',
    'P&L Reports': 'Laporan Laba Rugi',
    'Balance Sheets': 'Neraca',
    'Bank Account': 'Rekening Bank',
    'Bank Accounts': 'Rekening Bank',
    Statement: 'Mutasi',
    'Bank Statements': 'Mutasi Bank',
    Reconciliation: 'Rekonsiliasi',
    'Chart of Accounts': 'Daftar Akun',
    'Charge Code': 'Kode Biaya',
    'Charge Codes': 'Kode Biaya',
    'Tax Jurisdiction': 'Yurisdiksi Pajak',
    'Tax Jurisdictions': 'Yurisdiksi Pajak',
    'Tax Code': 'Kode Pajak',
    'Tax Codes': 'Kode Pajak',
    'Tax Rule': 'Aturan Pajak',
    'Tax Rules': 'Aturan Pajak',
    'Quotation / Rates': 'Quotation / Tarif',
    'Job Order': 'Job Order',
    'Job Orders': 'Job Order',
    'By Customer': 'Per Pelanggan',
    'By Date': 'Per Tanggal',
    'Driver Log': 'Log Pengemudi',
    'Driver Pay': 'Bayaran Pengemudi',
    Team: 'Tim',
    'My Trips': 'Perjalanan Saya',
    'My Pay': 'Gaji Saya',
    Driver: 'Pengemudi',
  },
  theme: {
    ...ms.theme,
    languageLabel: 'Bahasa',
  },
  svc: {
    ...ms.svc,
    status: {
      DRAFT: 'Draf', CONFIRMED: 'Dikonfirmasi', SCHEDULED: 'Dijadwalkan', DISPATCHED: 'Dikirim',
      IN_PROGRESS: 'Sedang Berjalan', COMPLETED: 'Selesai', INVOICED: 'Ditagih', CANCELLED: 'Dibatalkan',
      AVAILABLE: 'Tersedia', IN_USE: 'Sedang Digunakan', MAINTENANCE: 'Pemeliharaan', RETIRED: 'Dinonaktifkan',
      ON_DUTY: 'Bertugas', OFF_DUTY: 'Tidak Bertugas', ON_LEAVE: 'Cuti', ACTIVE: 'Aktif', INACTIVE: 'Tidak Aktif',
    },
    serviceType: {
      crane_lift: 'Angkat Crane', rigging: 'Rigging', transport: 'Transportasi', installation: 'Pemasangan',
      maintenance: 'Pemeliharaan', inspection: 'Inspeksi', other: 'Lainnya',
    },
    priority: { low: 'Rendah', normal: 'Normal', high: 'Tinggi', urgent: 'Mendesak' },
    equipmentType: {
      crane: 'Crane', forklift: 'Forklift', truck: 'Truk', generator: 'Generator',
      scaffold: 'Perancah', tool_set: 'Set Alat', other: 'Lainnya',
    },
    field: {
      customer: 'Pelanggan', site: 'Lokasi Kerja', serviceType: 'Jenis Layanan', priority: 'Prioritas',
      scheduledDate: 'Tanggal Jadwal', estHours: 'Estimasi Jam', description: 'Deskripsi', remarks: 'Catatan',
      assetCode: 'Kode Aset', name: 'Nama', type: 'Jenis', capacity: 'Kapasitas', serialNo: 'No. Seri',
      location: 'Lokasi', nextServiceDate: 'Tanggal Servis Berikutnya', code: 'Kode', crewName: 'Nama Kru',
      teamLeader: 'Ketua Tim', skills: 'Keahlian', siteCode: 'Kode Lokasi', siteName: 'Nama Lokasi',
      contact: 'Kontak', phone: 'Telepon', postalCode: 'Kode Pos', address: 'Alamat',
    },
    kpi: { totalOrders: 'Total Pesanan', scheduled: 'Dijadwalkan', inProgress: 'Sedang Berjalan', completed: 'Selesai' },
    tab: {
      recentOrders: 'Pesanan Terbaru', activeDispatched: 'Aktif / Dikirim', allOrders: 'Semua Pesanan',
      draft: 'Draf', active: 'Aktif', pendingDispatch: 'Menunggu Pengiriman', dispatched: 'Dikirim',
      allEquipment: 'Semua Peralatan', available: 'Tersedia', maintenance: 'Pemeliharaan',
      allCrews: 'Semua Kru', allSites: 'Semua Lokasi', allInvoices: 'Semua Tagihan',
      pendingBilling: 'Menunggu Tagihan', costBreakdown: 'Rincian Biaya', summary: 'Ringkasan',
    },
    col: {
      orderNo: 'No. Pesanan', customer: 'Pelanggan', site: 'Lokasi', type: 'Jenis', scheduled: 'Dijadwalkan',
      status: 'Status', crew: 'Kru', date: 'Tanggal', equipment: 'Peralatan', priority: 'Prioritas',
      estHrs: 'Est. Jam', created: 'Dibuat', assetCode: 'Kode Aset', name: 'Nama', capacity: 'Kapasitas',
      location: 'Lokasi', nextService: 'Servis Berikutnya', lastService: 'Servis Terakhir', code: 'Kode',
      crewName: 'Nama Kru', teamLeader: 'Ketua Tim', members: 'Anggota', skills: 'Keahlian',
      siteName: 'Nama Lokasi', address: 'Alamat', contact: 'Kontak', hours: 'Jam',
      materials: 'Material', total: 'Total', labor: 'Tenaga Kerja', totalCost: 'Total Biaya',
      revenue: 'Pendapatan', marginPct: 'Margin %', period: 'Periode', orders: 'Pesanan',
      completed: 'Selesai', cost: 'Biaya', avgHrsJob: 'Rata-rata Jam/Kerja', serialNo: 'No. Seri',
      phone: 'Telepon', postalCode: 'Kode Pos',
    },
    action: {
      confirm: 'Konfirmasi', schedule: 'Jadwalkan', dispatch: 'Kirim', startWork: 'Mulai Kerja',
      complete: 'Selesai', invoice: 'Tagih', cancel: 'Batalkan',
      cancelConfirm: 'Batalkan pesanan layanan ini?',
    },
    page: {
      dashboard: 'Manajemen Layanan', orders: 'Pesanan Layanan', dispatch: 'Pengiriman',
      equipment: 'Peralatan', crew: 'Kru', sites: 'Lokasi Kerja', billing: 'Tagihan Layanan',
      costing: 'Biaya Layanan', reports: 'Laporan Layanan',
    },
    dialog: {
      newOrder: 'Pesanan Layanan Baru', addEquipment: 'Tambah Peralatan', addCrew: 'Tambah Kru', addSite: 'Tambah Lokasi',
    },
  },
  chat: {
    ...ms.chat,
    searchPlaceholder: 'Cari…',
    newChat: 'Percakapan baru',
    noSessions: 'Belum ada percakapan.\nKlik + untuk memulai.',
    noSearchResults: 'Tidak ada percakapan yang cocok',
    archive: 'Arsipkan',
    delete: 'Hapus',
    archivedCount: 'Diarsipkan ({{count}})',
    restore: 'Pulihkan',
    managePrompts: 'Kelola Prompt Cepat',
    autoExecute: 'Kirim langsung saat diklik',
    confirmDelete: 'Apakah Anda yakin ingin menghapus "{{label}}"?',
    deleteFailed: 'Gagal menghapus percakapan',
    archived: 'Percakapan diarsipkan',
    restored: 'Percakapan dipulihkan',
    chatTitle: 'Obrolan',
    thinking: 'Berpikir…',
    share: 'Bagikan percakapan',
    typeToStart: 'Ketik di bawah untuk memulai percakapan',
    startTyping: 'Katakan sesuatu untuk memulai…',
    quickPrompts: 'Prompt Cepat',
    inputPlaceholder: 'Tanya apa saja… (Enter untuk kirim, Shift+Enter untuk baris baru)',
    stopRecording: 'Ketuk untuk berhenti',
    voiceInput: 'Ketuk untuk berbicara',
    stop: 'Hentikan pembuatan',
    disclaimer: 'Respons AI mungkin tidak akurat. Selalu verifikasi informasi penting.',
    shareTitle: 'Bagikan Percakapan',
    generateLink: 'Buat Tautan Berbagi',
    copied: 'Tersalin!',
    copy: 'Salin',
    shareWhatsApp: 'Bagikan melalui WhatsApp',
    expiresAt: 'Kedaluwarsa',
  },
  finance: {
    ...ms.finance,
    method: {
      bank_transfer: 'Transfer Bank',
      cheque: 'Cek',
      cash: 'Tunai',
      paynow: 'PayNow',
      fps: 'FPS',
      other: 'Lainnya',
    },
    col: {
      document: 'Dokumen',
      method: 'Metode',
      date: 'Tanggal',
      amount: 'Jumlah',
      unallocated: 'Belum Dialokasikan',
      allocated: 'Teraloaksi',
      status: 'Status',
    },
    kpi: {
      documents: 'Dokumen',
      unallocatedExposure: 'Belum Teralokasi',
    },
    controls: {
      title: 'Kontrol penyelesaian',
      committedCash: 'Pergerakan kas terikat',
      allocationOpen: 'Alokasi masih terbuka',
      unallocatedAmount: 'Jumlah belum teralokasi',
      requiresApproval: 'Perlu persetujuan',
      none: 'Tidak ada',
      yes: 'Ya',
      no: 'Tidak',
    },
    action: {
      assist: 'Bantu',
      refresh: 'Segarkan',
      void: 'Batalkan',
      reverse: 'Balikkan',
      apply: 'Terapkan',
    },
    dock: {
      header: 'Header {{title}}',
      appliedAllocations: 'Alokasi yang diterapkan',
      noAllocations: 'Belum ada alokasi.',
      lineBreakdown: 'Rincian baris pembayaran',
      noLines: 'Tidak ada rincian baris.',
      outstandingDocs: 'Dokumen mitra terutang',
      noOutstanding: 'Tidak ditemukan dokumen {{type}} terutang untuk mitra ini.',
      outstandingAmt: 'Terutang',
      noDueDate: 'Tidak ada jatuh tempo',
    },
    toast: {
      allocationApplied: 'Alokasi diterapkan',
      allocationReversed: 'Alokasi dibalikkan',
      noUnallocated: 'Tidak ada jumlah belum teralokasi',
      loadFailed: 'Gagal memuat {{entity}}',
      allocationFailed: 'Gagal menerapkan alokasi',
      reverseFailed: 'Gagal membalikkan alokasi',
      voidConfirm: 'Batalkan {{kind}} ini? Alokasi yang ada akan dibalikkan.',
      voided: '{{title}} dibatalkan',
      voidFailed: 'Gagal membatalkan {{entity}}',
    },
    empty: {
      selectRecord: 'Pilih catatan untuk memeriksa status alokasi dan dokumen mitra terutang.',
    },
  },
} as const;

export default id;
